import { isEqual, unionWith } from 'lodash'

export default function arrayUnion(originalArray, newArray) {
  return unionWith(originalArray, newArray, isEqual)
}
